export const SESSION_STORAGE = {
  KEYCLOAK_TOKEN: 'keycloakToken',
  REFRESH_TOKEN: 'refreshToken'
};
